import React from 'react';
import ReactDOM from 'react-dom';

export default class HomeComponent extends React.Component {
	render () {
		return (
			< div >Home< /div >
		);
	}
};



/** WEBPACK FOOTER **
 ** ./app/components/home.component.js
 **/